import { TSection as TDeleteSection } from '../repositories/chats/entities/all_from_section_desktop_request/PublicV1ChatsBulkOperationsDeleteAllFromSectionDesktopRequestSchema';
import { TSection as TArchiveSection } from '../repositories/chats/entities/all_from_section_desktop_request/PublicV1ChatsBulkOperationsMoveAllFromSectionToArchiveDesktopRequestSchema';
import { TSection as TReadSection } from '../repositories/chats/entities/all_from_section_desktop_request/PublicV1ChatsBulkOperationsReadAllFromSectionDesktopRequestSchema';

export enum ERoute {
  Messages = 'messages',
  Spam = 'spam',
  Archive = 'archive',
  Unread = 'unread',
  Starred = 'starred',
}

export type TRoute = `${ERoute}`;

export type { TArchiveSection, TReadSection, TDeleteSection };
